import axios from '../../../../utils/api'
import modulo from '@/utils/modulo'

const actions = {

  async findEnderecoIterpa ({ commit }, id) {
    const endereco = await axios({
      method: 'get',
      url: modulo.PUBLICO + '/findEnderecoById',
      params: {
        id
      }
    })
    return endereco
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/portal/seguranca/endereco.js